/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var BoxIcon = createIcon("BoxIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M22.302 16.302c.269.376.215.859-.107 1.127-.375.269-.912.215-1.18-.107l-1.878-2.415-1.825 2.361c-.268.376-.805.376-1.18.108-.376-.269-.43-.752-.161-1.127l2.146-2.79-2.146-2.79c-.269-.376-.161-.913.16-1.181.376-.268.913-.161 1.181.16l1.825 2.415 1.878-2.307c.268-.376.75-.43 1.18-.16.376.267.376.804.107 1.18l-2.092 2.736 2.092 2.79Zm-9.765-.322c-1.396 0-2.522-1.073-2.522-2.468 0-1.341 1.127-2.468 2.522-2.468 1.395 0 2.521 1.127 2.521 2.468-.053 1.395-1.18 2.468-2.521 2.468Zm-7.405 0c-1.395 0-2.522-1.073-2.522-2.468 0-1.341 1.127-2.468 2.522-2.468 1.395 0 2.522 1.127 2.522 2.468 0 1.395-1.127 2.468-2.522 2.468Zm7.405-6.546c-1.557 0-2.952.859-3.65 2.147-.697-1.288-2.092-2.147-3.702-2.147a4.41 4.41 0 00-2.522.805V6.805A.825.825 0 001.86 6c-.484 0-.86.376-.86.805v6.76a4.111 4.111 0 004.132 4.025c1.61 0 3.005-.912 3.702-2.2.698 1.288 2.093 2.2 3.649 2.2 2.307 0 4.185-1.824 4.185-4.131.054-2.2-1.824-4.025-4.131-4.025Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});